<template>
  <div id="app">
    <div id="overlay-common" />
    <div class="d-flex flex-column min-h-screen">
      <BaseHeader v-if="isLogin && !isIframe" />
      <div class="d-flex flex-1 overflow-hidden">
        <BaseLeftMenu v-if="isLogin" />
        <div id="main-wrapper" class="flex-1" v-if="isLogin">
          <BaseBreadCrumb />
          <div>
            <router-view />
          </div>
        </div>
        <div v-else>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseHeader from "@/components/common/BaseHeader";
import BaseLeftMenu from "@/components/common/BaseLeftMenuTraiPhang";
import BaseBreadCrumb from "@/components/common/BaseBreadCrumb";

import { mapGetters } from "vuex";

export default {
  name: "App",
  metaInfo: {
    title: "Hệ thống Quản lý người dùng",
    meta: [
      {
        name: "description",
        content: "Hệ thống Quản lý người dùng",
      },
    ],
  },
  components: {
    BaseHeader,
    BaseLeftMenu,
    BaseBreadCrumb,
  },
  computed: {
    ...mapGetters({
      isLogin: "common/isLogin",
      isIframe: "common/isIframe",
    }),
  },
};
</script>

<style lang="scss">
@import "assets/css/base/index";
//@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap");

html,
body {
  font-family: "Arial", sans-serif;
}

#app {
  font-family: "Arial", sans-serif;
}
</style>
